import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  Typography,
  DialogActions,
  Button
} from '@mui/material';

const rootDialogStyle = {
  padding: '1rem'
};

const textAreaStyle = {
  resize: 'none',
  width: '100%',
  height: '6em'
};

function AddCommentDialog({
  handleClose,
  isOpen,
  encounterId,
  addCommentToEncounter
}) {
  const [commentText, setCommentText] = useState('');

  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      fullWidth
      maxWidth="md"
      disableEscapeKeyDown
    >
      <div style={rootDialogStyle}>
        <div>
          <h3>Add Comment</h3>
        </div>

        <div>
          <textarea
            style={textAreaStyle}
            value={commentText}
            maxLength="400"
            onChange={e => {
              e.preventDefault();
              e.stopPropagation();
              const val = e.target.value;
              setCommentText(val);
            }}
          />
          <span>{commentText.length}/400</span>
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={handleClose}
          >
            Cancel
          </button>

          <button
            onClick={() => {
              addCommentToEncounter(encounterId, commentText)
                .then(() => {
                  setCommentText('');
                });
            }}
          >
            Add
          </button>
        </div>
      </div>
    </Dialog>
  );
}

AddCommentDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  encounterId: PropTypes.number.isRequired,
  addCommentToEncounter: PropTypes.func.isRequired
};

export { AddCommentDialog };
